import React from 'react';

interface AutoMarginProps {
  className?: string;
}

const AutoMargin: React.FC<AutoMarginProps> = ({ children, className }) => {
  return (
    <div className="flex">
      <div className="hidden lg:inline-block lg:flex-margin w-1/3" />
      <div className={className}>{children}</div>
      <div className="hidden lg:inline-block lg:flex-margin w-1/3" />
    </div>
  );
};

export default AutoMargin;
